/**
 * Build Your Bundle - checkbox toggle recomputes the WAS/TODAY total, and
 * "Add bundle to cart" adds every checked row's variant in ONE request.
 *
 * Pairs with snippets/bundle-box.liquid. The multi-add + refresh pattern
 * mirrors assets/hc-discount-gift.js:519-548 exactly: POST /cart/add.js with
 * an `items` array, then dispatch `theme:cart:refresh`. That event alone
 * re-renders the cart drawer AND opens it (theme.dev.js:1298 -> getCart() ->
 * build() dispatches `theme:product:added` -> CartDrawer's
 * openCartDrawerOnProductAdded), so no separate open-drawer call is needed.
 */
(function () {
  function fmt(cents) {
    if (window.theme && typeof theme.formatMoney === 'function') return theme.formatMoney(cents, theme.moneyFormat);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, Shopify.money_format);
    return '$' + (cents / 100).toFixed(2);
  }

  function checkedRows(root) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-bundle-row]'), function (row) {
      var box = row.querySelector('[data-bundle-check]');
      return box && box.checked;
    });
  }

  function updateTotals(root) {
    var rows = checkedRows(root);
    var was = 0;
    var now = 0;
    rows.forEach(function (row) {
      was += parseInt(row.getAttribute('data-was') || '0', 10);
      now += parseInt(row.getAttribute('data-now') || '0', 10);
    });

    var wasEl = root.querySelector('[data-bundle-total-was]');
    var nowEl = root.querySelector('[data-bundle-total-now]');
    if (wasEl) wasEl.textContent = fmt(was);
    if (nowEl) nowEl.textContent = fmt(now);

    var addBtn = root.querySelector('[data-bundle-add]');
    if (addBtn) addBtn.disabled = rows.length === 0;
  }

  function showMessage(root, text) {
    var msg = root.querySelector('[data-bundle-message]');
    if (!msg) return;
    msg.hidden = !text;
    msg.textContent = text || '';
  }

  // Cart-drawer upsells, product recommendations, quick-add, and the bundle box
  // itself ALSO carry name="id" inputs and .mcd-near-* price nodes. A bare
  // document.querySelector would grab whichever comes first in the DOM (often a
  // cart-drawer upsell for a DIFFERENT product), so every "main product" lookup
  // must skip these containers.
  var NON_MAIN =
    '[data-bundle-box], cart-drawer, cart-notification, quick-add-modal,' +
    ' quick-order-list, product-recommendations, .product-recommendations,' +
    ' .product-upsell__form, .complementary-products, [data-product-recommendations]';

  function mainScoped(selector) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      if (!els[i].closest(NON_MAIN)) return els[i];
    }
    return null;
  }

  // Allowed variant ids of the CURRENT product (rendered by Liquid onto the row).
  // The current row may only ever resolve to one of these - a belt-and-braces
  // guard so a stray name="id" from another product can never be added as "the
  // current product".
  function currentVariantSet(root) {
    var row = root.querySelector('[data-bundle-current]');
    var set = {};
    var raw = row ? row.getAttribute('data-current-variants') || '' : '';
    raw.split(',').forEach(function (x) {
      var n = parseInt(x, 10);
      if (n) set[n] = true;
    });
    return set;
  }

  // The shopper's currently-selected variant of the CURRENT product, read from
  // the MAIN product form (Broadcast keeps its name="id" in sync with the variant
  // picker). Reading it at click time means the bundle adds the material they
  // actually chose (e.g. Top-Grain), not the SSR default (Vegan). Returns the id
  // only if it belongs to the current product; otherwise null (caller keeps the
  // SSR variant).
  function mainVariantId(root) {
    var el = mainScoped('input[name="id"], select[name="id"]');
    if (!el) return null;
    var v = parseInt(el.value, 10);
    if (!v) return null;
    var allowed = currentVariantSet(root);
    // If no allowlist was rendered, fall back to trusting the scoped lookup.
    if (Object.keys(allowed).length && !allowed[v]) return null;
    return v;
  }

  function moneyToCents(text) {
    if (!text) return null;
    var f = parseFloat(String(text).replace(/[^0-9.,]/g, '').replace(/,/g, ''));
    return isNaN(f) ? null : Math.round(f * 100);
  }

  // Keep the locked current-product row in step with the PDP's own price box and
  // selected variant, so the bundle adds the chosen material AND never advertises
  // a price different from what the PDP shows. Mirrors the mcd near-ATC box
  // (.mcd-near-was/.mcd-near-sale) - the same source the sticky cart bar mirrors -
  // which already reflects the session's discount + selected variant.
  function syncCurrentRow(root) {
    var row = root.querySelector('[data-bundle-current]');
    if (!row) return;

    var vid = mainVariantId(root);
    if (vid) row.setAttribute('data-variant-id', String(vid));

    var mcdWas = mainScoped('.mcd-near-was, [data-mcd-near-was]');
    var mcdSale = mainScoped('.mcd-near-sale, [data-mcd-near-sale]');
    var wasC = mcdWas ? moneyToCents(mcdWas.textContent) : null;
    var nowC = mcdSale ? moneyToCents(mcdSale.textContent) : null;
    var rowWas = row.querySelector('.byb__was');
    var rowNow = row.querySelector('.byb__now');

    if (wasC != null) {
      row.setAttribute('data-was', String(wasC));
      if (rowWas && mcdWas) rowWas.textContent = mcdWas.textContent.trim();
    }
    if (nowC != null) {
      row.setAttribute('data-now', String(nowC));
      if (rowNow && mcdSale) rowNow.textContent = mcdSale.textContent.trim();
    } else if (wasC != null && rowNow && mcdWas) {
      // No discount showing on the PDP: mirror the real price, don't invent one.
      row.setAttribute('data-now', String(wasC));
      rowNow.textContent = mcdWas.textContent.trim();
    }
    updateTotals(root);
  }

  function addBundleToCart(root) {
    var addBtn = root.querySelector('[data-bundle-add]');
    var rows = checkedRows(root);
    if (!rows.length || !addBtn) return;

    // Reflect the live variant/material selection before reading the row ids.
    syncCurrentRow(root);
    var currentRow = root.querySelector('[data-bundle-current]');

    var originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    showMessage(root, '');

    // Dedupe the current product against what's already in the cart (the shopper
    // may have added it via the main Add-to-Cart), so "Add bundle" never creates
    // a duplicate handbag line. Siblings are added exactly as ticked.
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; });

        var items = [];
        rows.forEach(function (row) {
          var id = Number(row.getAttribute('data-variant-id'));
          if (!id) return;
          if (row === currentRow && inCart[id]) return; // skip duplicate current product
          items.push({ id: id, quantity: 1, properties: { _build_your_bundle: 'true' } });
        });

        if (!items.length) {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
          showMessage(root, 'These items are already in your cart.');
          window.setTimeout(function () { showMessage(root, ''); }, 4000);
          return;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            addBtn.textContent = originalText;
            if (!result.ok) {
              // One row sold out mid-session: surface it and re-enable so the
              // shopper can uncheck it and retry, instead of dead-ending here.
              showMessage(
                root,
                (result.data && (result.data.description || result.data.message)) ||
                  'Sorry, one of those items just sold out. Please uncheck it and try again.'
              );
              window.setTimeout(function () {
                addBtn.disabled = checkedRows(root).length === 0;
              }, 8000);
              return;
            }

            showMessage(root, 'Added to your cart!');
            addBtn.disabled = checkedRows(root).length === 0;
            document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
            window.setTimeout(function () { showMessage(root, ''); }, 4000);
          });
      })
      .catch(function () {
        addBtn.textContent = originalText;
        addBtn.disabled = checkedRows(root).length === 0;
        showMessage(root, 'Something went wrong adding the bundle. Please try again.');
      });
  }

  // Re-sync the locked current row whenever the PDP variant picker changes.
  // The mcd near-ATC box re-renders/updates its text on variant change, so
  // observing it (plus the raw variant input) reliably catches material swaps.
  function watchCurrentVariant(root) {
    if (!root.querySelector('[data-bundle-current]')) return;

    var target =
      mainScoped('[data-mcd-near]') ||
      mainScoped('.mcd-near-price') ||
      mainScoped('.mcd-near-sale');
    if (target && window.MutationObserver) {
      new MutationObserver(function () {
        syncCurrentRow(root);
      }).observe(target, { childList: true, subtree: true, characterData: true });
    }

    var input = mainScoped('input[name="id"], select[name="id"]');
    if (input) {
      input.addEventListener('change', function () {
        syncCurrentRow(root);
      });
    }
  }

  function bind(root) {
    if (root.dataset.bundleBound) return;
    root.dataset.bundleBound = '1';

    root.querySelectorAll('[data-bundle-check]:not([data-bundle-locked])').forEach(function (box) {
      box.addEventListener('change', function () {
        updateTotals(root);
      });
    });

    var addBtn = root.querySelector('[data-bundle-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBundleToCart(root);
      });
    }

    watchCurrentVariant(root);
    syncCurrentRow(root);
    updateTotals(root);
  }

  function init() {
    document.querySelectorAll('[data-bundle-box]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-bind when this block's section re-renders.
  document.addEventListener('shopify:section:load', init);
})();
